import { render, staticRenderFns } from "./FormSuggestion.vue?vue&type=template&id=4a61842e&"
import script from "./FormSuggestion.vue?vue&type=script&lang=js&"
export * from "./FormSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports